import React from 'react';

const IncludeManyPeople = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-include-many" />
    </div>
  );
};

export default IncludeManyPeople;
